<script setup>
import { computed } from 'vue';

const props = defineProps({
  total: {
    type: Number,
    default: 10,
    required: true,
  },
  current: {
    type: Number,
    default: 1,
    required: true,
  },
});

const stepClass = computed(() => {
  let progress = 100 / props.total;
  return Math.round(progress * props.current);
});
</script>

<template>
  <div class="container-fluid">
    <div class="row d-flex align-items-center">
      <div class="col-10 col-sm-11">
        <div class="progress">
          <div
            class="progress-bar"
            role="progressbar"
            :style="{ width: stepClass + '%' }"
            aria-valuenow="25"
            aria-valuemin="0"
            aria-valuemax="100"
            aria-label="progressbar"
          />
        </div>
      </div>
      <div
        data-wg-notranslate
        class="col-2 col-sm-1 text-end text-lg-center fw-bold"
      >
        {{ stepClass }}{{ $t('general.header.percentage') }}
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.progress-bar {
  background-color: var(--theme-color-groen-100);
}
</style>
